import { useRef, useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import { recordingApi } from 'api';
import { VideoRecorderService } from 'services/videoRecorder';
import { useUserContext } from 'providers/UserProvider';

const useVideoRecording = () => {
  const { selectedWarehouse } = useUserContext();
  const serviceRef = useRef(null);
  const [stream, setStream] = useState(null);
  const isEnabled = !!selectedWarehouse?.is_picking_video_enabled;

  useEffect(() => {
    if (!isEnabled) return;

    let cancelled = false;
    const service = new VideoRecorderService(recordingApi);
    serviceRef.current = service;

    service
      .initialize()
      .then(() => {
        if (cancelled) return;

        if (service.getError()) {
          toast.warning(
            'Camera not available. Picking will continue without video recording.',
          );
        } else {
          setStream(service.stream);
        }
      })
      .catch(() => {
        if (!cancelled) {
          toast.warning(
            'Camera not available. Picking will continue without video recording.',
          );
        }
      });

    return () => {
      cancelled = true;
      service.destroy();
      serviceRef.current = null;
      setStream(null);
    };
  }, [isEnabled]);

  const onShipmentStart = useCallback(shipmentId => {
    serviceRef.current?.onShipmentStart(shipmentId);
  }, []);

  const onShipmentEnd = useCallback(shipmentId => {
    serviceRef.current?.onShipmentEnd(shipmentId);
  }, []);

  const onShipmentSidelined = useCallback(() => {
    serviceRef.current?.onShipmentSidelined();
  }, []);

  return { stream, onShipmentStart, onShipmentEnd, onShipmentSidelined };
};

export default useVideoRecording;
